import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import PeriodStartDateSelector from '~/modules/common/charts/dashboard/PeriodStartDateSelector';
import { PeriodSelector, StickyHeader } from '~/modules/common/components';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import { useMeContext } from '~/modules/me/useMeContext';
import {
  ResourcingActualToggleButton,
  ResourcingDisplayUnitToggleButtonGroup,
  ResourcingLegends,
  ResourcingPeriodDropDown
} from '~/modules/resourcing/common/components';
import { PERIOD_SCALE_ENUM } from '~/modules/resourcing/common/enums';
import { useResourcingChartToolbarContext } from '../../hooks';
import ResourceRequestImportExportMenu from '../ResourceRequestImportExportMenu';

const useLegendStyles = makeStyles(() => ({
  root: {
    width: '100%'
  }
}));

const useStyles = makeStyles(theme => ({
  spacer: {
    flexGrow: 1,
    flexShrink: 1,
    padding: theme.spacing(0, 1)
  }
}));

export const ResourceRequestToolbar = ({ classes: classesOverride }) => {
  const {
    displayUnit,
    setDisplayUnit,
    scale,
    dateRange,
    setScale,
    onPrevious,
    onNext,
    isResourceActualModeEnabled,
    setIsResourceActualModeEnabled,
    legends,
    setDate
  } = useResourcingChartToolbarContext();

  const {
    featureFlags: { isPSAQuickAllocationDemandEnabled, isRmp2025Q3Enhancements }
  } = useMeContext();
  const legendClasses = useLegendStyles();
  const classes = useStyles({ classes: classesOverride });

  const isMobile = useIsBreakpointDown('sm');
  const PeriodSelectorComponent = isRmp2025Q3Enhancements
    ? PeriodStartDateSelector
    : PeriodSelector;

  return (
    <StickyHeader level={3}>
      {scale !== PERIOD_SCALE_ENUM.OVERVIEW && (
        <PeriodSelectorComponent
          onPreviousClick={onPrevious}
          onNextClick={onNext}
          dateRange={dateRange}
          scale={scale}
          setDate={setDate}
        />
      )}
      <div className={classes.spacer} />
      <ResourcingLegends
        legends={legends}
        classes={legendClasses}
        showNewLegends
      />
      <ResourcingActualToggleButton
        isResourceActualModeEnabled={isResourceActualModeEnabled}
        setIsResourceActualModeEnabled={setIsResourceActualModeEnabled}
      />

      {scale !== PERIOD_SCALE_ENUM.OVERVIEW ? (
        <ResourcingDisplayUnitToggleButtonGroup
          displayUnit={displayUnit}
          setDisplayUnit={setDisplayUnit}
        />
      ) : null}

      <ResourcingPeriodDropDown
        scale={scale}
        setScale={setScale}
        showYears={!isPSAQuickAllocationDemandEnabled}
        data-qe-id="ResourcePeriodDropdown"
      />
      {!isMobile && <ResourceRequestImportExportMenu isMobile={isMobile} />}
    </StickyHeader>
  );
};

ResourceRequestToolbar.propTypes = {
  classes: PropTypes.object
};

export default ResourceRequestToolbar;
